import React from 'react'
import { Link, graphql } from "gatsby"
import Layout from '../components/layout'
import SEO from "../components/seo"

import Cover from '../components/cover/cover'

export const data = graphql`
query($slug: String!){
    contentfulCollectionDrives(slug: {eq: $slug}) {
    slug
    name
    description {
        description
    }
    images {
      file {
        url
      }
    }
    thumbnail {
      file {
        url
      }
    }
  }
}
`;


const CollectionsTemplate = ({data: {contentfulCollectionDrives: {name, slug, description, images, thumbnail}}}) => {
    return (
    <Layout>
        <SEO title={`We Clothe Them - ${name}`} />
        <Cover image={thumbnail.file.url} title={name} paragraph={description ? description.description : ''} />
        <section>
            <div className={`content`}>
                <h6 className={`letter-spaced-heading center`}>Gallery</h6>
                <h2 className={`center`}>A few glimpses of the collection drive</h2>
                <div className={`gallery`}>
                    {images.map((image, index)=>(
                        <div className={`image`} key={index}>
                            <img src={image.file.url} alt={`${name} Photograph`} />
                        </div>
                    ))}
                </div>
                <div className={`group-center`}>
                    <Link to="/collections"><button>Back to Collections</button></Link>
                </div>
            </div>
        </section>
    </Layout>
    )
}

export default CollectionsTemplate